"use client";

import { cn } from "@/lib/utils";
import { motion, Variants } from "motion/react";
import React from "react";

type TextAnimationProps = {
  text: string;
  className?: string;
  customEasing?: number[];
  delay?: number;
  y?: string;
};

const containerVariants: Variants = {
  hidden: {},
  visible: (delay: number = 0) => ({
    transition: {
      staggerChildren: 0.015,
      delayChildren: delay,
    },
  }),
};

const charVariants: Variants = {
  hidden: ({ y }: { y?: string } = {}) => ({
    y: y || "70%",
  }),
  visible: ({ customEasing }: { customEasing?: number[] } = {}) => ({
    y: "0%",
    transition: {
      duration: 1.5,
      ease: customEasing || [0.3, 0, 0.2, 1],
    },
  }),
};

const TextAnimation = ({
  text,
  className,
  customEasing,
  delay,
  y,
}: TextAnimationProps) => {
  return (
    <motion.div
      className={cn("overflow-hidden w-fit flex", className)}
      variants={containerVariants}
      custom={delay}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
      }}
    >
      {text.split("").map((char, i) => (
        <div key={i}>
          <motion.div variants={charVariants} custom={{ customEasing, y }}>
            {char === " " ? "\u00A0" : char}
          </motion.div>
        </div>
      ))}
    </motion.div>
  );
};

export default TextAnimation;
